<script setup lang="ts">
import { UserStore } from "@/store/userStore";
const userStore = UserStore();
import LandingLogoLight from "@/assets/images/LandingLogoLight.svg";
import LandingLogoDark from "@/assets/images/LandingLogo.svg";
</script>
<template>
  <div class="footer-container">
    <footer class="scroll-reveal">
      <img
        class="footer-logo footer-logo-mobile"
        :src="
          userStore.theme
            ? '/src/assets/images/LandingLogoLight.svg'
            : '/src/assets/images/LandingLogo.svg'
        "
        alt="OmniTasker"
      />
      <hr />
      <div class="footer-items">
        <a
href="https://enonsolutions.com/"
target="_blank"
          >Created by ENON Solutions</a
        >
        <img
          class="footer-logo footer-logo-desktop"
          :src="userStore.theme ? LandingLogoLight : LandingLogoDark"
          alt="OmniTasker"
        />
        <a
href="https://marsengine.net/"
target="_blank"
          >Powered by MARS Engine</a
        >
      </div>
    </footer>
  </div>
</template>
<style lang="scss" scoped>
.footer-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

footer {
  width: 100%;
  max-width: 1262px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--figma-space-3xl);
  padding-block: var(--figma-space-3xl);

  hr {
    width: 100%;
    border-color: var(--figma-color-text-text-very-muted);
  }

  img {
    height: 1rem;
    width: auto;
  }
}

.footer-logo-mobile {
  display: none;
}

.footer-items {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  a {
    text-decoration: none;
    color: var(--figma-color-text-text-very-muted);
    font-size: var(--figma-typography-font-size-text-lg);
  }
}

@media (max-width: 1400px) {
  footer {
    width: 100%;
    padding-block: var(--figma-space-3xl);
    padding-inline: var(--figma-space-3xl);
  }
}

@media (max-width: 1000px) {
  .footer-items a {
    font-size: var(--figma-typography-font-size-text-md);
  }
}

@media (max-width: 800px) {
  .footer-items {
    a {
      font-size: var(--figma-typography-font-size-text-sm);
    }

    img {
      height: 0.8rem;
    }
  }
}

@media (max-width: 600px) {
  footer {
    gap: var(--figma-space-lg);
  }

  .footer-logo-mobile {
    display: block;
    height: 0.625rem;
    width: auto;
  }

  .footer-logo-desktop {
    display: none;
  }
}
</style>
